import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-79bfecbb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-item-container mb-6 no-drag" }
const _hoisted_2 = { class: "fixed-content-container" }
const _hoisted_3 = { class: "header pb-2" }
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = { class: "font-weight-black" }
const _hoisted_6 = { class: "header-tool-icons" }
const _hoisted_7 = {
  ref: "collapsableContentContainer",
  class: "collapsable-content-container"
}
const _hoisted_8 = { style: {"overflow":"hidden"} }
const _hoisted_9 = { class: "body pb-1" }
const _hoisted_10 = { class: "font-weight-black" }
const _hoisted_11 = {
  key: 0,
  class: "body pb-1"
}
const _hoisted_12 = { class: "font-weight-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_icon, {
              class: "item-icon cursor-move",
              icon: "mdi-drag-vertical",
              size: "large"
            }),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('i18n.textLabelTitle')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_btn, {
              class: "cursor-pointer",
              variant: "text",
              icon: "",
              onClick: _ctx.duplicateItem,
              disabled: !_ctx.userCanEditFormItems
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { icon: "$gorateDuplicate" }),
                _createVNode(_component_v_tooltip, {
                  activator: "parent",
                  location: "start"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.duplicate')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_v_btn, {
              class: "cursor-pointer",
              variant: "text",
              icon: "",
              onClick: _ctx.removeItem,
              disabled: !_ctx.userCanEditFormItems
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "small",
                  icon: "$gorateDeleteOutline"
                }),
                _createVNode(_component_v_tooltip, {
                  activator: "parent",
                  location: "start"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.remove')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_v_btn, {
              class: "cursor-pointer",
              variant: "text",
              icon: "",
              onClick: _ctx.expandGrid,
              disabled: !_ctx.userCanEditFormItems
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: _ctx.expandGridButtonIconName,
                  size: "large"
                }, null, 8, ["icon"]),
                _createVNode(_component_v_tooltip, {
                  activator: "parent",
                  location: "start"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.collapse')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('i18n.language1')), 1),
            (!_ctx.userCanEditFormItems)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  activator: "parent",
                  location: "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.editNotAvailable')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_textarea, {
              density: "compact",
              placeholder: _ctx.$t('i18n.titleLang1'),
              variant: "outlined",
              dense: "",
              "hide-details": "auto",
              modelValue: _ctx.itemData.text_label_lang1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemData.text_label_lang1) = $event)),
              rows: "4",
              clearable: "",
              "no-resize": "",
              counter: "",
              rules: _ctx.textRules,
              disabled: !_ctx.userCanEditFormItems
            }, null, 8, ["placeholder", "modelValue", "rules", "disabled"])
          ]),
          (_ctx.bilingual)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('i18n.language2')), 1),
                _createVNode(_component_v_textarea, {
                  density: "compact",
                  placeholder: _ctx.$t('i18n.questionLang2'),
                  variant: "outlined",
                  dense: "",
                  "hide-details": "auto",
                  modelValue: _ctx.itemData.text_label_lang2,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemData.text_label_lang2) = $event)),
                  rows: "4",
                  clearable: "",
                  "no-resize": "",
                  counter: "",
                  rules: _ctx.textRules
                }, null, 8, ["placeholder", "modelValue", "rules"])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 512)
    ]),
    _createVNode(_component_v_divider, {
      thickness: 2,
      class: "border-opacity-100 mb-3",
      color: "grey"
    })
  ], 64))
}